import React from "react";
import styled from 'styled-components';
import { Icon } from '.';
export const StyledRightArrowIcon = styled(Icon) `
  color: ${({ theme }) => theme.primaryBlack};
`;
export const StyledLeftArrowIcon = styled(Icon) `
  color: ${({ theme }) => theme.secondaryBlue};
  left: -15px;
  position: absolute;
  font-size: 45px;
`;
export const StyledDownArrowIcon = styled(Icon) `
  color: ${({ theme }) => theme.primaryRed};
  font-size: ${({ fontSize }) => (!!fontSize ? `${fontSize}px` : '26px')};
`;
// Workaround fix for an icon-related issue on Primary Navigation in IE
export const DownArrowSVG = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M7 10l5 5 5-5z", fill: "#DC2440" }),
        React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
};
